import React, { useMemo } from 'react';
import BarChart from './BarChart';
import { MONTHS } from '../constants';
import { fmt } from '../format';
import { getMonthIndex, getSalesAmount, sum } from '../salesCalculations';
import { cardStyle } from '../styles';

// Number of invoices and average invoice amount (net + freight) per month, credit invoices included.
// Every chart is its own card so that they are laid out like the other graphs.
const InvoiceStats = ({ invoices, lastMonth, showWeb, showOther }) => {
    const stats = useMemo(() => MONTHS.map((_, m) => {
        const list = invoices.filter((o) => getMonthIndex(o) === m);
        const average = (items) => (items.length > 0 ? sum(items.map(getSalesAmount)) / items.length : 0);
        return {
            count: list.length,
            averageWeb: average(list.filter((o) => o.isWeb)),
            averageOther: average(list.filter((o) => !o.isWeb))
        };
    }), [invoices]);

    const visible = (values) => values.map((value, m) => (m <= lastMonth ? value : null));

    const note = (
        <div style={{ fontSize: '0.75rem', color: '#777', marginTop: '0.5rem' }}>
            Netto + frakt per faktura. Kreditfakturor r&auml;knas med, makulerade fakturor g&ouml;r det inte. M&aring;nad enligt fakturadatum.
        </div>
    );

    return (
        <>
            <div style={{ ...cardStyle, padding: '1rem' }}>
                <strong>Antal fakturor per m&aring;nad</strong>
                <BarChart
                    categories={MONTHS}
                    series={[{ name: 'Antal fakturor', color: '#1779ba', values: visible(stats.map((s) => s.count)) }]}
                    formatValue={(v) => fmt(v)}
                    height={220}
                />
                {note}
            </div>

            {showWeb && (
                <div style={{ ...cardStyle, padding: '1rem' }}>
                    <strong>Snittfakturav&auml;rde per m&aring;nad &ndash; Webb</strong>
                    <BarChart
                        categories={MONTHS}
                        series={[{ name: 'Webb', color: '#1779ba', values: visible(stats.map((s) => s.averageWeb)) }]}
                        formatValue={(v) => `${fmt(v)} kr`}
                        height={220}
                    />
                    {note}
                </div>
            )}

            {showOther && (
                <div style={{ ...cardStyle, padding: '1rem' }}>
                    <strong>Snittfakturav&auml;rde per m&aring;nad &ndash; &Ouml;vrigt</strong>
                    <BarChart
                        categories={MONTHS}
                        series={[{ name: '\u00d6vrigt', color: '#2e9e6b', values: visible(stats.map((s) => s.averageOther)) }]}
                        formatValue={(v) => `${fmt(v)} kr`}
                        height={220}
                    />
                    {note}
                </div>
            )}
        </>
    );
};

export default InvoiceStats;
